import { useMutation } from "@tanstack/react-query";
import { updateRoles as apiEditRoles } from "../../api/apiRoles";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useUpdateRoles() {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    const {
        mutate: editRoles,
        isPending: isUpdate,
        data: results,
        error,
    } = useMutation({
        mutationFn: ({ req, id }) => apiEditRoles(req, id),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            navigate('/roles');
        },
        onError: (err) => {
            console.error("Error:", err);
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { editRoles, isUpdate, error, results };
}
